// extracted by mini-css-extract-plugin
export default {"welcomeSection":"WelcomeONas_welcomeSection__arNg8","welcomeContainer":"WelcomeONas_welcomeContainer__3VIYv","welcomeText":"WelcomeONas_welcomeText__NRtib"};